<template lang="pug">
el-dialog(
  title="Add Event"
  top="5vh" width="100%"
  class="el-dialog__max-w-700"
  :close-on-click-modal="false"
)
  .row
    .col-4
      el-upload(
        :show-file-list="false"
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :http-request="handleEventUpload"
        action=""
      ).img-uploader
        template(v-if="item.img")
          img(:src="item.img").img-fluid
          .pin.pin-bx.d-flex.p-2
            el-button(type="primary").ms-auto Change
        template(v-else)
          img(src="@/assets/icons/file-image-outline.svg").img-uploader-icon
          p.upload-picture-text Drop an image file here or
          div.fake-upload-button Browse For File

    .col-8
      el-form(
        ref="refForm"
        :rules="rules"
        :model="item"
        status-icon
        label-position="top"
      )
        el-form-item(label="Title" prop="title")
          el-input(v-model="item.title")

        el-form-item(label="Details" prop="description")
          el-input(v-model="item.description" type="textarea")

        el-form-item(label="Date and Time")
          el-date-picker(
            v-model="item.date"
            type="datetime"
            placeholder="Select date and time"
          ).w-100

        el-form-item(label="Source")
          el-input(v-model="item.source")

  template(#footer)
    el-button(type="success" @click="validateForm" v-loading="loading") Add
</template>

<script>

import {
  ref,
  reactive,
  defineComponent,
} from 'vue';
import { requiredRule } from '@/data/rules';
import fileUpload from '@/shared/upload';

export default defineComponent({
  name: 'DialogAddEvent',
  props: {
    loading: { type: Boolean, default: false },
  },
  emits: ['close-dialog', 'save-item'],

  setup(_, { emit }) {
    const { uploadStatus, beforeUpload, handleUploadRequest } = fileUpload('events', 'Event');

    const refForm = ref(null);

    const item = reactive({
      id: null,
      title: '',
      img: null,
      date: null,
      description: '',
    });

    function submitForm() {
      emit('save-item', item);
      emit('close-dialog');
    }

    function validateForm() {
      refForm.value.validate((valid) => {
        if (valid) return submitForm();
        console.log('error submit!!');
        return false;
      });
    }

    async function handleEventUpload(payload) {
      await handleUploadRequest(payload);
      if (uploadStatus.status === 'ok') {
        item.img = uploadStatus.resourceUrl;
      }
    }

    function handleSuccess() {
      console.log('succc');
    }

    function handleError() {
      console.log('error');
    }

    return {
      // data
      beforeUpload,
      handleEventUpload,
      handleSuccess,
      handleError,

      refForm,
      rules: {
        url: requiredRule('url'),
        title: requiredRule('title'),
        description: requiredRule('description'),
      },
      item,
      // methods
      validateForm,

    };
  },
});
</script>
